// DS: DS2.6
import React from 'react';
import c from 'classnames';
import PlainButtonOrLink, { Props as ButtonProps } from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import SimpleTooltip from '@wix/da-ds/pkg/tooltips/dsPreset/SimpleTooltip';
import ConditionalWrapper from '@wix/da-ds/pkg/ConditionalWrapper';
import { IconSize, Props as IconProps } from '@wix/da-ds/pkg/Icons/IconWrap';
import s from './ToggleButton.scss';

export type Props = {
  tooltipText?: string;
  activated?: boolean;
  icon: React.ComponentType<IconProps>;
  iconRef?: React.RefObject<HTMLElement | null> | ((node: HTMLElement | null) => void);
  label?: React.ReactNode;
  children?: undefined;
} & ButtonProps;

const ToggleButton: React.FC<React.PropsWithChildren<Props>> = ({
  tooltipText,
  activated,
  disabled,
  icon: Icon,
  iconRef,
  label,
  className,
  ...rest
}) => {
  return (
    <ConditionalWrapper
      condition={tooltipText !== undefined}
      wrap={child => (
        <SimpleTooltip text={tooltipText!} placement="top">
          {child}
        </SimpleTooltip>
      )}
    >
      <PlainButtonOrLink
        className={c(s['root'], activated && s['on'], disabled && s['disabled'], className)}
        disabled={disabled}
        {...rest}
      >
        <Icon
          className={s['icon']}
          size={IconSize.MEDIUM}
          disableDefaultColors
          containerRef={iconRef}
        />
        {label && <span className={s['label']}>{label}</span>}
      </PlainButtonOrLink>
    </ConditionalWrapper>
  );
};

ToggleButton.displayName = 'ToggleButton';

export default ToggleButton;
